import { createAuthClient } from 'better-auth/react';
import { magicLinkClient, twoFactorClient } from 'better-auth/client/plugins';
import { passkeyClient } from '@better-auth/passkey/client';

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: '/api/ba',
  plugins: [magicLinkClient(), twoFactorClient(), passkeyClient()],
});

/** Google login button is only shown when the deployment has OAuth credentials configured. */
export const GOOGLE_LOGIN_ENABLED = import.meta.env['VITE_GOOGLE_LOGIN'] === 'true';
